import { Col, Row } from 'antd';
import { FC, ReactNode } from 'react';

import { Sider } from '@/modules/Sider';

import { CommonLayoutContainer } from './CommonLayoutContainer';
import { CommonLayoutDrawer } from './CommonLayoutDrawer';
import { CommonLayoutHeader } from './CommonLayoutHeader';

import './CommonLayout.scss';

interface Props {
  commonRouter: ReactNode;
  drawerRouter: ReactNode;
}

export const CommonLayout: FC<Props> = ({ commonRouter, drawerRouter }) => {
  return (
    <Row wrap={false}>
      <Col flex="220px">
        <Sider />
      </Col>
      <Col flex={'auto'}>
        <Row wrap>
          <Col span={24}>
            <Row justify="space-between">
              <Col span={24}>
                <CommonLayoutHeader />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row wrap={false} style={{ height: 'calc(100vh - 55px)' }}>
          <Col flex="auto">
            <CommonLayoutContainer>{commonRouter}</CommonLayoutContainer>
          </Col>

          <Col>
            <CommonLayoutDrawer>{drawerRouter}</CommonLayoutDrawer>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
